import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UILink from 'UIComponents/link/UILink';
import UIImage from 'UIComponents/image/UIImage';
import UICardSection from 'UIComponents/card/UICardSection';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { USD } from 'self-service-api/constants/CurrencyCodes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Headline = styled.h3.withConfig({
  displayName: "Case__Headline",
  componentId: "qmfmty-0"
})(["font-size:1rem;"]);
const Bold = styled.span.withConfig({
  displayName: "Case__Bold",
  componentId: "qmfmty-1"
})(["font-weight:600;"]);
const CompanyInfoAndMetrics = styled.div.withConfig({
  displayName: "Case__CompanyInfoAndMetrics",
  componentId: "qmfmty-2"
})(["display:grid;grid-template-columns:repeat(2,1fr);grid-column-gap:12px;"]);
const Case = ({
  caseStudyKey,
  href,
  logo,
  price,
  externalLink = true,
  cardWrapperProps
}) => {
  const handleLinkClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'case-study-link',
      url: href
    });
  };
  const companyInfoKeys = Object.keys(I18n.text(`case-studies.cases.${caseStudyKey}.companyInfo`));
  const metrics = I18n.text(`case-studies.cases.${caseStudyKey}.metrics`, {
    defaultValue: ''
  });
  const metricsKeys = Object.keys(typeof metrics === 'string' || !metrics ? {} : metrics);
  return /*#__PURE__*/_jsxs(UICardWrapper, Object.assign({}, cardWrapperProps, {
    children: [/*#__PURE__*/_jsx(UICardSection, {
      className: "p-bottom-8",
      children: /*#__PURE__*/_jsx(UIImage, {
        alt: caseStudyKey,
        src: logo,
        responsive: false,
        height: 40
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: /*#__PURE__*/_jsx(Headline, {
        children: /*#__PURE__*/_jsx(Bold, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `case-studies.cases.${caseStudyKey}.headline`
          })
        })
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `case-studies.cases.${caseStudyKey}.description_jsx`,
          elements: {
            Price: () => {
              return price ? /*#__PURE__*/_jsx(PriceDisplay, {
                price: price,
                currencyCode: USD
              }) : '';
            }
          }
        }), "\xA0", /*#__PURE__*/_jsxs(UILink, {
          external: externalLink,
          href: href,
          onClick: handleLinkClick,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "case-studies.learnMore"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            className: "sr-only",
            message: `case-studies.cases.${caseStudyKey}.headline`
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      className: "m-top-auto",
      children: /*#__PURE__*/_jsxs(CompanyInfoAndMetrics, {
        children: [/*#__PURE__*/_jsx("div", {
          children: companyInfoKeys.map(key => /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Bold, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `case-studies.companyInfo.labels.${key}`
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `case-studies.cases.${caseStudyKey}.companyInfo.${key}`
            })]
          }, key))
        }), /*#__PURE__*/_jsx("div", {
          children: metricsKeys.map(key => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: `case-studies.cases.${caseStudyKey}.metrics.${key}`,
              elements: {
                Price: () => {
                  return price ? /*#__PURE__*/_jsx(PriceDisplay, {
                    price: price,
                    currencyCode: USD
                  }) : '';
                },
                Bold,
                FormattedCurrency,
                // TODO - remove after translations
                FormattedPercentage
              }
            })
          }, key))
        })]
      })
    })]
  }));
};
export default Case;